const getSteps = () => ['identification', 'contact_person', 'territories', 'subscription', 'summary'];

export default {
    getSteps
};
